



import profile from './../media/img/dp1.png'
import dp2 from './../media/img/dp2.png'
import rs_logo_block from './../media/img/rs_logo_block.png'
import rs_logo_single_nb from './../media/img/rs_logo_single_nb.png'
import rs_logo_glow from './../media/img/rs_logo_glow.png'
import tech_logo from './../media/img/tech_logo.png'

import new_rosa_logo_single from './../media/img/rs_logo_single_new.png'
import new_rosa_logo_block from './../media/img/rs_logo_block_new.png'
import rosa_text from './../media/img/rs_logo_text.png'


import bgelipse from './../media/img/bgelipse.png'

import rs1 from './../media/img/rs_c1.png'
import rs2 from './../media/img/rs_c2.jpeg'
import rs3 from './../media/img/rs_c3.png'
import rs4 from './../media/img/rs4.jpg'
import rs4_1 from './../media/img/rs4_1.jpg'
import rs5 from './../media/img/rs5.jpg'

import rs_ring from './../media/img/rs_ring.png'
import mobile_app_demo from './../media/img/mobile_app_demo.png'
import trailer_img from './../media/img/trailer_img.png'
import drop_ring from './../media/img/drop_ring.png'
import event from './../media/img/event.png'
import dp_shadow from './../media/img/dp_shadow.png'
import rings from './../media/img/rings.png'
import app_store_badge from './../media/img/app_store_badge.png'
import g_play_badge from './../media/img/g_play_badge.png'

import ev_logo_single from './../media/img/ev_logo_single.png'
import eva_logo_green from './../media/img/logo-single.png'
import samo_dp1 from './../media/img/samo_dp1.png'
import samo_dp2 from './../media/img/samo_dp2.png'
import sol_logo from './../media/img/sol_logo.png'




export const images = {

    general: {
        profile,
        rs_logo_block,
        rs_logo_single_nb,
        dp2,
        tech_logo,
        rs_logo_glow,

        new_rosa_logo_block,
        new_rosa_logo_single,
        rosa_text,
        
        ev_logo_single,
        eva_logo_green,
        samo_dp1,
        samo_dp2,
        sol_logo,
    },

    web_page: {
        rs_ring,
        mobile_app_demo,
        trailer_img,
        drop_ring,
        rings,
        dp_shadow,
        event,
        app_store_badge,
        g_play_badge,
    },

    sidebar: {
        bgelipse,
    },

    home: {
        // lsm
    },

    wellness: {
        
    },

    connect: {
        rs1,
        rs2,
        rs3,
        rs4,
        rs4_1,
        rs5,
        rs3,
        rs4,
        rs4_1,
        rs5,
    },

}